import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  toggleGroup: {
    display: 'flex',
    width: '100%',
  },
  toggleButton: {
    flex: '1 1 0',
    textTransform: 'none',
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white,
    },
  },
}))

export default useStyles
